import { Pedido } from '@/models/pedido'

interface CadastroEmpresaForm{
  currentStep: number;
  isLoading: boolean;
  data: Pedido;
  documentos: Array<any>;
  error: any;
}

export const initialStateCadastroEmpresaForm: CadastroEmpresaForm = {
  currentStep: 1,
  isLoading: false,
  data: null,
  documentos: [],
  error: null,
}

export default {
  form: initialStateCadastroEmpresaForm
}
